<template>
    <router-link :to="partnerUrl"
        :class="['token-tile', { 'token-tile--disabled': !partnerUrl }]"
    >
        <div class="token-tile__header smoothen-lines"
            :style="{ backgroundColor: partner.mainColour }"
        />

        <partner-logo class="token-tile__logo"
            :url="partner.partnerLogo"
        />

        <div :class="['token-tile__title', {'token-tile__title--has-graph': market.graphPartnerColor}]">
            <div class="token-tile__label token-tile__label--emphasized">{{ partner.shortName }}</div>
            <div class="token-tile__label">{{ partner.name }}</div>
        </div>

        <img v-if="market.graphPartnerColor"
            :src="market.graphPartnerColor"
            class="token-tile__graph"
        >

        <div class="token-tile__price">
            <div class="token-tile__label token-tile__label--emphasized">{{ tokenPrice.value }}</div>
            <div class="flex">
                <div v-if="isPriceAvailable && isChzAllowed"
                    class="token-tile__label"
                >
                    {{ tokenPrice.altValue }}
                </div>

                <div :class="['token-tile__label', 'fluctuation', { 'fluctuation--down' : parseFloat(tokenPrice.evolutionPercentage) < 0 }]">
                    {{ tokenPrice.evolutionPercentage }}
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import {
    mapGetters,
} from 'vuex';

// Components
import partnerLogo from '@webapp/components/partner-logo/partner-logo.vue';

// Mixins
import tokenItemMixin from '@webapp/helpers/token-item-mixin.js';

export default {
    name: 'token-offering-tile',
    components: {
        partnerLogo,
    },
    mixins: [tokenItemMixin],
    props: {
        tokenOfferingId: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            status: '',
            tokenPrice: {
                value: 0,
                fiatValue: 0,
                info: '',
                state: '',
            },
        };
    },
    computed: {
        ...mapGetters('marketplace', ['marketByPartnerId']),

        ...mapGetters('partners', ['partnerById']),

        ...mapGetters('wallet', ['isChzAllowed']),

        partner() {
            return this.partnerById(this.tokenOfferingId);
        },

        isPriceAvailable() {
            return parseInt(this.tokenPrice.rawValue) >= 0;
        },

        partnerUrl() {
            return this.partner.id ? `/partner/${this.partner.id}` : '';
        },

        market() {
            return this.marketByPartnerId(this.tokenOfferingId);
        },
    },
};
</script>

<style lang="scss" scoped>
a {
    text-decoration: none;
}

.token-tile {
    color: $cyprus-color;
    background-color: $seashell-color;
    box-shadow: 0 1rem 1.5rem rgba($black-color, 0.25);
    transition: 0.05s ease-in;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 18rem;
    height: 22.5rem;
    border-radius: 1rem;
    padding: 1.5rem 0;
    margin: 2rem 2rem 3rem;

    &:hover {
        cursor: pointer;
        opacity: 0.8;
    }

    &--disabled {
        pointer-events: none;
        opacity: 0.5;
    }

    &__header {
        position: absolute;
        height: 8rem;
        width: 124%;
        transform: rotate(-7deg);
        left: -2rem;
        top: -2rem;
        border-bottom: 1rem solid $white-color;
        background-color: $alto-color;
    }

    &__logo {
        min-width: 9rem;
        min-height: 9rem;
        max-width: 9rem;
        max-height: 9rem;
        margin: 0 1.5rem;
    }

    &__title,
    &__label {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    &__title {
        margin-bottom: 2rem;
        border-bottom: 0.15rem solid $white-color;
        padding: 0 1.5rem 2rem 1.5rem;

        &--has-graph {
            margin-bottom: 0;
            padding-bottom: 0.5rem;
            border: none;
        }
    }

    &__graph {
        width: 100%;
        padding-bottom: 0.5rem;
        object-fit: contain;
    }

    &__price {
        padding: 0 1.5rem;
    }

    &__label {
        font-size: 1.4rem;
        padding: 0 0.25rem;

        &--emphasized {
            font-size: 2rem;
            font-weight: bold;
        }

        &.fluctuation {
            color: $lima-color;

            &--down {
                color: $monza-color;
            }
        }
    }
}

.flex {
    display: flex;

    div {
        &:first-child {
            margin-right: auto;
        }
    }
}
</style>